import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import { getBilling } from "redux/actions/UserBilling";
import { onLoaderTrigger } from "redux/actions/commonAction";
import store from "redux/store";
import { GET_BILLING, GET_BILLINGAPPROVAL } from "resources/actionTypes";
import { billingApi, billingApprovalApi } from "services/BillingService";

function* fetchBilling(action) {

  try {
    const payload = action.payload || {}
    const userBilling = yield call(billingApi, payload);

    yield put({ type: GET_BILLING.GET_BILLING_SUCCESS, userBilling: userBilling });
  } catch (e) {
    yield put({ type: GET_BILLING.GET_BILLING_FAILED, message: e.message });
  }
}

export function* billingSagaWatcher() {
  yield takeEvery(GET_BILLING.GET_BILLING_REQUESTED, fetchBilling);
}

function* fetchBillingApproval(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {};
  const frontdeskBillingApproval = yield call(
    billingApprovalApi,
    payload?.formPayload
  );
  if (frontdeskBillingApproval?.success) {
    yield put({ type: GET_BILLINGAPPROVAL.GET_BILLINGAPPROVAL_SUCCESS });
    toast.success(frontdeskBillingApproval.message);
    store.dispatch(onLoaderTrigger(false));
    payload?.handleSelectedRows([]);

    if(payload?.formPayload?.magicToken){
      store.dispatch(getBilling({magicToken:payload?.formPayload?.magicToken}))
    }else{
      store.dispatch(getBilling())
    }
  } else {
    yield put({
      type: GET_BILLINGAPPROVAL.GET_BILLINGAPPROVAL_FAILED,
      message: frontdeskBillingApproval.message,
    });
    store.dispatch(onLoaderTrigger(false));
    toast.error(frontdeskBillingApproval.message);
  }
}

export function* billingApprovalSaga() {
  yield takeEvery(GET_BILLINGAPPROVAL.GET_BILLINGAPPROVAL_REQUESTED, fetchBillingApproval);
}
